// extracted by mini-css-extract-plugin
export default {"lanscapeAboutLandscapeAddWrapper":"LandscapeAboutLandscapeAddPage_lanscapeAboutLandscapeAddWrapper__4EKQi"};